import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import RefundTopbar from "../../features/manageRefunds/topbar";
import RefundList from "../../features/manageRefunds/refundList";

const ManageRefunds = () => {
  const navigate = useNavigate();

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Refunds</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage Refunds
        </p>
      </div>

      <div className="cards">
        <RefundList />
      </div>
    </MainContainer>
  );
};

export default ManageRefunds;
